import { FC } from "react";
import { useTranslation } from "react-i18next";

import { RASTER_LANDINGS, SVG_LANDINGS } from "@ryde/assets-landings";

import { DownloadsAppButtons } from "../../widgets";

export const StepFinishedTnufa: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SVG_LANDINGS.GreenSVG
        className="v-green-icon text-green"
        aria-hidden="true"
      />
      <h1 className="landing-title font-size-30 text-green">
        {t("landing.finished.title1")}
      </h1>
      <p className="landing-title font-size-30 text-grey">
        {t("landing.finished.title2")}
      </p>

      <div className="divider-bar-label" aria-hidden="true" />

      <div className="landing-sub-title font-size-18 text-grey">
        {t("landing.finished.tnufaFinishedFirstLine")}
      </div>
      <div className="landing-sub-title font-size-18 text-grey">
        {t("landing.finished.tnufaFinishedSecondLine")}
      </div>

      <div className="divider-bar" aria-hidden="true" />

      <DownloadsAppButtons />

      <div className="landing-bottom-illustration" aria-hidden="true"></div>

      <div className="landing-container-footer">
        <div className="landing-container-footer-logo">
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.RideLogoPNG}
            alt="Ryde logo"
            width="120"
            height="51"
          />
        </div>
      </div>
    </>
  );
};
